import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withState, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import GroupShopDepositTableGroup from './GroupShopDepositTableGroup';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import { sendLogin } from '../../auth/Auth';
import { getGroupDetail } from '../../actions/Groups';
import { getAccounts } from '../../actions/Accounts';
import ShopAddGroup from './ShopAddGroup';

const styles = theme => ({
  root: {
    display: 'flex'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(0),
    width: 'calc(100% - 240px)'
  },
  title: {
    color: '#000',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 15
  },
  pageTitle: {
    fontSize: 20,
    fontWeight: 'bold'
  },
  mainPaper: {
    position: 'relative',
    margin: '20px 0'
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  formFlex: {
    display: 'flex',
    alignItems: 'end'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  button: {
    margin: '5px 0 5px 5px'
  },
  buttonLeft: {
    textAlign: 'left'
    // CSV出力ボタンを実装時にコメントアウトを外す
    // float: 'left'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  buttonGroupRight: {
    textAlign: 'right'
  },
  tableTopDiv: {
    display: 'flex',
    textAlign: 'right',
    alignItems: 'flex-end'
  },
  flexRight: {
    marginLeft: 'auto'
  },
  bottomButtonDiv: {
    // padding: '10px 26px 10px 0px',
    textAlign: 'right'
  },
  fs10: {
    fontSize: '10px !important'
  },
  searchForm: {
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: 15
  },
  formControl: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 5,
    paddingRight: 5,
    width: 'auto'
  },
  subTitle: {
    fontWeight: 'bold',
    fontSize: 10,
    marginRight: 5,
    color: '#000000'
  },
  textField120: {
    width: 120
  },
  textField200: {
    width: 200
  },
  buttonSearch: {
    fontSize: 10,
    marginLeft: 10,
    fontWeight: 'bold',
    paddingTop: 9
  },
  btnCsv: {
    fontSize: 12,
    fontWeight: 'bold',
    marginLeft: 'auto',
    marginBottom: 20
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      groupDetail: state.groups.detail
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGroupDetail,
          getAccounts
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openShopAdd', 'updateOpenShopAdd', false),
  withState('openShopAddConfirm', 'updateOpenShopAddConfirm', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('groupId', 'setGroupId', ''),
  withState('unnarrowDownGroup', 'setUnnarrowDownGroup', true),
  withState('groupName', 'setGroupName', ''),
  withState('cityId', 'setCityId', ''),
  withState('address', 'setAddress', null),
  withState('depositManage', 'setDepositManage', ''),
  withState('rowsPerPage', 'setRowsPerPage', 10),
  withState('paymentGroupType', 'setPaymentGroupType', ''),
  withState('filterParams', 'setFilterParams', {}),
  withState('hideRowsPerPage', 'setHideRowsPerPage', true),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangeRowsPerPage: props => event => {
      props.setRowsPerPage(event.target.value);
    }
  })
);

const Main = enhance(
  ({
    classes,
    account,
    month,
    monthYear,
    shopId,
    setShopId,
    shopName,
    setShopName,
    handleChangePage,
    handleChangeRowsPerPage,
    openTable,
    openShopAdd,
    updateOpenShopAdd,
    openShopAddConfirm,
    updateOpenShopAddConfirm,
    loading,
    openProgress,
    groupId,
    cityId,
    setCityId,
    address,
    unnarrowDownGroup,
    depositManage,
    paymentGroupType,
    page,
    totalCount,
    limit,
    setFilterParams,
    setRowsPerPage,
    hideRowsPerPage,
    currencyFormat,
    shops,
    downloadCsvAction,
    currentMonthYear,
    fromTopPageGroup,
    isFukuoka,
    isTable2
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 10;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchKey = {
      groupId,
      shopName,
      address,
      unnarrowDownGroup,
      page,
      limit: limitNum
    };
    const groupShop = true;

    const searchAction = async () => {
      const newFilterParams = {
        shopId: shopId || undefined,
        shopName: shopName || undefined
      };
      setFilterParams(newFilterParams);
      handleChangePage(null, 1, limitNum, newFilterParams, monthYear);
    };
    const exportCSV = () => {
      console.log('export csv action');
      const newFilterParams = {
        shopId: shopId || undefined,
        shopName: shopName || undefined
      };
      downloadCsvAction(null, 1, limitNum, newFilterParams, monthYear);
    };
    const shopCancelAction = () => updateOpenShopAdd(false);
    const shopBackAction = () => updateOpenShopAddConfirm(false);

    let title = `グループ店舗情報一覧 (${month}月)`;
    if (isFukuoka) {
      title = `教室別精算情報（${month}月）`;
      if (isTable2) {
        title = `過去の精算金額・教室別（${month}月）`;
      }
    }

    return (
      <div className={classes.root}>
        <main className={classes.content}>
          {!fromTopPageGroup && (
            <>
              <Typography color="textPrimary" className={classes.pageTitle}>
                {title}
              </Typography>
              <div className={classes.searchForm}>
                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    {isFukuoka ? '教室ID' : '店舗ID'}
                  </FormLabel>
                  <TextField
                    placeholder="例) 0123"
                    type="search"
                    InputProps={{
                      classes: {
                        input: clsx(classes.textField120, classes.fs10)
                      }
                    }}
                    variant="outlined"
                    size="small"
                    value={shopId}
                    onChange={e => {
                      setShopId(e.target.value);
                    }}
                  />
                </FormControl>
                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    {isFukuoka ? '教室名' : '店舗名'}
                  </FormLabel>
                  <TextField
                    placeholder={
                      isFukuoka ? '例）Gigi〇〇校' : '例) Gigi 〇〇店'
                    }
                    type="search"
                    InputProps={{
                      classes: {
                        input: clsx(classes.textField200, classes.fs10)
                      }
                    }}
                    variant="outlined"
                    size="small"
                    value={shopName}
                    onChange={e => {
                      setShopName(e.target.value);
                    }}
                  />
                </FormControl>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.buttonSearch}
                  onClick={searchAction}
                >
                  検索
                </Button>
              </div>
              <div className={classes.tableTopDiv}>
                <ExPaginationGroup
                  count={
                    totalCount % limit > 0
                      ? Math.floor(totalCount / limit) + 1
                      : Math.floor(totalCount / limit)
                  }
                  selectedPage={page}
                  handleChangePage={handleChangePage}
                  limit={limit}
                  setLimit={setRowsPerPage}
                  totalCount={totalCount}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  hideRowsPerPage={hideRowsPerPage}
                />
                {totalCount !== 0 && totalCount && (
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={exportCSV}
                    className={classes.btnCsv}
                  >
                    エクスポート
                  </Button>
                )}
              </div>
            </>
          )}
          {openTable && (
            <Paper variant="outlined" square>
              <GroupShopDepositTableGroup
                shops={shops}
                roles={roles}
                searchKey={searchKey}
                page={page}
                handleChangePage={handleChangePage}
                selectedPage={page}
                currencyFormat={currencyFormat}
                currentMonthYear={currentMonthYear}
                fromTopPageGroup={fromTopPageGroup}
                isFukuoka={isFukuoka}
                isTable2={isFukuoka && isTable2}
              />
            </Paper>
          )}
          {!fromTopPageGroup && (
            <div className={classes.bottomButtonDiv}>
              <ExPaginationGroup
                count={
                  totalCount % limit > 0
                    ? Math.floor(totalCount / limit) + 1
                    : Math.floor(totalCount / limit)
                }
                selectedPage={page}
                handleChangePage={handleChangePage}
                limit={limit}
                setLimit={setRowsPerPage}
                totalCount={totalCount}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                hideRowsPerPage={hideRowsPerPage}
              />
            </div>
          )}
          <div>
            <Modal open={openShopAdd}>
              <ShopAddGroup
                openShopAddConfirm={openShopAddConfirm}
                updateOpenShopAdd={updateOpenShopAdd}
                updateOpenShopAddConfirm={updateOpenShopAddConfirm}
                groupDepositManage={depositManage}
                paymentGroupType={paymentGroupType}
                cancelAction={shopCancelAction}
                backAction={shopBackAction}
                searchKey={searchKey}
                groupShop={groupShop}
                roles={roles}
                cityId={cityId}
                setCityId={setCityId}
              />
            </Modal>
          </div>
        </main>

        <ProgressDialog openProgress={openProgress} loading={loading} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
